module.exports = __webpack_public_path__ + "img/customerwechat.7f924bd8.png";